export default __webpack_public_path__ + "5bf6f73448c376bae972e797fedfcc3d.png";